import { throttle } from 'throttle-debounce';

function animateNavOnScroll(){
    const elNavContainer = document.getElementById( 'aw-nav-wrapper' );
    const elNavRoot = elNavContainer?.querySelector<HTMLElement>( '#aw-nav-root' );
    if( !elNavContainer || !anime ) return;

    anime.set( elNavContainer, {
        background: 'var(--bs-body-bg)',
    });

    let lastScrollTop = 0;
    let isVisible = false;
    let isAnimating = false;
    let scrollUpDistance = 0;
    const SCROLL_UP_THRESHOLD = 50;

    function animateNavIn(){
        if( isAnimating || isVisible ) return;

        isAnimating = true;
        elNavContainer?.classList.add( 'position-sticky' );
        elNavRoot?.classList.add( 'border-bottom' );

        anime({
            targets: elNavContainer,
            opacity: [ 0, 1 ],
            translateY: [ '-20%', '0%' ],
            duration: 200,
            easing: 'easeOutQuad',
            complete: () => {
                isAnimating = false;
                isVisible = true;
            }
        });
    }

    function animateNavOut(){
        // If animateNavIn is mid-flight, cancel it and snap to hidden immediately
        if( isAnimating && !isVisible ){
            anime.remove( elNavContainer );
            isAnimating = false;
            elNavContainer?.classList.remove( 'position-sticky' );
            elNavRoot?.classList.remove( 'border-bottom' );
            anime({ targets: elNavContainer, opacity: 0, translateY: '-20%', duration: 0 });
            return;
        }

        if( isAnimating || !isVisible ) return;

        isAnimating = true;

        anime({
            targets: elNavContainer,
            // opacity: [ 1, 0 ],
            translateY: [ '0%', '-100%' ],
            duration: 200,
            easing: 'easeInQuad',
            complete: () => {
                isAnimating = false;
                isVisible = false;
                elNavContainer?.classList.remove( 'position-sticky' );
                elNavRoot?.classList.remove( 'border-bottom' );
            }
        });
    }

    function resetNav(){
        if( !isVisible && !isAnimating ) return;

        anime.remove( elNavContainer );
        isAnimating = true;

        anime({
            targets: elNavContainer,
            opacity: 0,
            duration: 0,
            easing: 'linear',
            complete: () => {
                isAnimating = false;
                isVisible = false;
                elNavContainer?.classList.remove( 'position-sticky' );
                elNavRoot?.classList.remove( 'border-bottom' );
                anime({ targets: elNavContainer, opacity: [0, 1], translateY: '0%', background: 'none', duration: 300 });
            }
        });
    }

    function animateNav(){
        const currentY = window.scrollY;

        if( currentY <= 800 ){
            scrollUpDistance = 0;
            resetNav();
        } else if( currentY < lastScrollTop ){
            scrollUpDistance += lastScrollTop - currentY;
            if( scrollUpDistance >= SCROLL_UP_THRESHOLD ){
                animateNavIn();
            }
        } else {
            scrollUpDistance = 0;
            animateNavOut();
        }

        lastScrollTop = currentY;
    }

    const throttleAnimate: EventListener = throttle(
        50,
        () => animateNav()
    ) as EventListener;

    window.addEventListener( 'scroll', throttleAnimate, {
        passive: true
    } );
}

document.addEventListener('DOMContentLoaded', () => {

    // If body has class "nav-overlaps-content" or "home", don't animate the nav on scroll
    if( document.body.classList.contains( 'nav-overlaps-content' )
        || document.body.classList.contains( 'home' )
        || window?.noStickyNav === true // Add window.noStickyNav === true using a custom HTML block on pages that do not need sticky nav (e.g. homepage, landing pages, etc.)
    ){
        return;
    }
    animateNavOnScroll();
});
